module.exports = __webpack_public_path__ + "img/mask-group.31856437.png";